import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { importProvidersFrom } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './services/auth.interceptor';
import { ApiDataService } from './services/api.service';
import { provideToastr } from 'ngx-toastr';
import { UsersApiDataService } from './users/users-api.service';
import { ShService } from './services/sh-service';
import { OrgApiDataService } from './org/org.service';
import { StoreApiDataService } from './store/store.service';
import { DashboardApiDataService } from './dashboard/dashboard-api.service';
import { ReportDataService } from './reports/reports-api.service';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { PalletApiDataService } from './pallets/pallet.service';
import { SupportApiDataService } from './support/support.service';
import { TransferApiDataService } from './transfer/transfer.service';
import { ConfigApiDataService } from './config/services/config-api.service';
import { ConfigService } from './config/services/config.service';

export const appConfig: ApplicationConfig = {
  
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptorsFromDi()),
    provideEnvironmentNgxMask(),  
    {
        provide:HTTP_INTERCEPTORS,
        useClass:AuthInterceptor,
        multi:true
    },
    importProvidersFrom([BrowserAnimationsModule]),
    {
      provide: ShService
    },
    {
      provide: ApiDataService
    },
    {
      provide: DashboardApiDataService
    },
    {
      provide: UsersApiDataService
    },
    {
      provide: OrgApiDataService
    },
    {
      provide: StoreApiDataService
    },
    {
      provide: ReportDataService
    },
    {
      provide: PalletApiDataService
    },
    {
      provide: SupportApiDataService
    },
    {
      provide: TransferApiDataService
    },
    {
      provide: ConfigApiDataService
    },
    {
      provide: ConfigService
    },
    {
      provide: AuthInterceptor
    },
    provideToastr({})
  ]
};
